var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_281764",
    clipPath: "url(#clip0_2769_19682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.93242 12.086L4.23625 14.6849L1.69176 14.7388C0.931328 13.3283 0.5 11.7146 0.5 9.99979C0.5 8.34154 0.903281 6.77779 1.61812 5.40088H1.61867L3.88398 5.81619L4.87633 8.06791C4.66863 8.67342 4.55543 9.32342 4.55543 9.99979C4.55551 10.7338 4.68848 11.4372 4.93242 12.086Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.3252 8.13184C20.44 8.73676 20.4999 9.36148 20.4999 9.99996C20.4999 10.7159 20.4246 11.4143 20.2812 12.0879C19.7944 14.3802 18.5224 16.3818 16.7604 17.7983L16.7598 17.7978L13.9065 17.6522L13.5027 15.1313C14.6719 14.4456 15.5857 13.3725 16.067 12.0879H10.7197V8.13184H16.145H20.3252Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.7595 17.7979L16.7601 17.7985C15.0464 19.176 12.8694 20.0001 10.4996 20.0001C6.69141 20.0001 3.38043 17.8716 1.69141 14.7392L4.93207 12.0864C5.77656 14.3403 7.95074 15.9447 10.4996 15.9447C11.5952 15.9447 12.6216 15.6485 13.5024 15.1315L16.7595 17.7979Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.883 2.30219L13.6434 4.95437C12.7319 4.38461 11.6544 4.05547 10.5 4.05547C7.89344 4.05547 5.67859 5.73348 4.87641 8.06812L1.61871 5.40109H1.61816C3.28246 2.1923 6.6352 0 10.5 0C12.9264 0 15.1511 0.864297 16.883 2.30219Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2769_19682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.585e61976820b76f9800e5c4f3ac59be.svg";
export { ForwardRef as ReactComponent };